import React from "react";
import { parseText } from "utils/functions/text";

import {
  Container,
  Name,
  AccountInformationsWrapper,
  Agency,
  Account,
  ProfileInformations
} from "./styles";

function AccountBoxOption({ id, name, agency, account, profile, taxIdentifier, isSelected, onSelect, isBlocked }) {
  return (
    <Container
      id="AccountBoxOptionDiv"
      isSelected={isSelected}
      isBlocked={isBlocked}
      idIndex={id}
      onClick={() => { onSelect(id) }}>
      <Name id="AccountBoxOptionAccountLabel" >{name ? parseText({ text: name, limit: 21 }) : ""}</Name>
      <AccountInformationsWrapper blocked={isBlocked}>
        <Agency id="AccountBoxOptionBranchLabel">AG {agency}</Agency>
        <Account id="AccountBoxOptionAccountLabel">CONTA {account}</Account>
      </AccountInformationsWrapper>
      {profile && <ProfileInformations id="lastAccessLabel">
        {profile === 'PF' ? `CPF ${taxIdentifier}` : `CNPJ ${taxIdentifier}`}
      </ProfileInformations>}
      {
        isBlocked ? (
          <>
            <ProfileInformations blocked>
              Conta Bloqueada - Procuração Vencida
            </ProfileInformations>
            <ProfileInformations blocked smaller>
              Entre em contato com nosso SAC<br />Mais informações no seu e-mail
            </ProfileInformations>
          </>
        ) : ''
      }
    </Container>
  );
}

export default AccountBoxOption;
